import React, { useState } from 'react';
import { PricingView } from './PricingView';
export const LiveFeedView = () => {
  const [activeSection, setActiveSection] = useState('activity');
  // Sample live feed data
  const liveFeedItems = [{
    id: 1,
    type: 'booking',
    message: 'New booking: Ocean View Room for Oct 15-18',
    timestamp: new Date(Date.now() - 5 * 60000) // 5 minutes ago
  }, {
    id: 2,
    type: 'revenue',
    message: 'Daily revenue target exceeded by 15%',
    timestamp: new Date(Date.now() - 27 * 60000) // 27 minutes ago
  }, {
    id: 3,
    type: 'occupancy',
    message: 'Suite occupancy reached 90% for tomorrow',
    timestamp: new Date(Date.now() - 52 * 60000) // 52 minutes ago
  }, {
    id: 4,
    type: 'booking',
    message: 'Booking cancellation: Deluxe Room for Oct 10-12',
    timestamp: new Date(Date.now() - 118 * 60000) // ~2 hours ago
  }, {
    id: 5,
    type: 'system',
    message: 'Forecast updated for next weekend',
    timestamp: new Date(Date.now() - 180 * 60000) // 3 hours ago
  }, {
    id: 6,
    type: 'revenue',
    message: 'ADR increased by $12 compared to last week',
    timestamp: new Date(Date.now() - 240 * 60000) // 4 hours ago
  }, {
    id: 7,
    type: 'booking',
    message: 'Group booking: 5 Standard Rooms for Nov 5-8',
    timestamp: new Date(Date.now() - 360 * 60000) // 6 hours ago
  }];
  // Format relative time
  const getRelativeTime = timestamp => {
    const now = new Date();
    const diffInMinutes = Math.floor((now - timestamp) / (1000 * 60));
    if (diffInMinutes < 1) return 'Just now';
    if (diffInMinutes < 60) return `${diffInMinutes}m ago`;
    const diffInHours = Math.floor(diffInMinutes / 60);
    if (diffInHours < 24) return `${diffInHours}h ago`;
    const diffInDays = Math.floor(diffInHours / 24);
    return `${diffInDays}d ago`;
  };
  // Get icon based on activity type
  const getActivityIcon = type => {
    switch (type) {
      case 'booking':
        return <div className="bg-blue-100 p-2 rounded-full" data-id="element-211">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-blue-600" viewBox="0 0 20 20" fill="currentColor" data-id="element-212">
              <path d="M5 4a2 2 0 012-2h6a2 2 0 012 2v14l-5-2.5L5 18V4z" data-id="element-213" />
            </svg>
          </div>;
      case 'revenue':
        return <div className="bg-green-100 p-2 rounded-full" data-id="element-214">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-green-600" viewBox="0 0 20 20" fill="currentColor" data-id="element-215">
              <path d="M8.433 7.418c.155-.103.346-.196.567-.267v1.698a2.305 2.305 0 01-.567-.267C8.07 8.34 8 8.114 8 8c0-.114.07-.34.433-.582zM11 12.849v-1.698c.22.071.412.164.567.267.364.243.433.468.433.582 0 .114-.07.34-.433.582a2.305 2.305 0 01-.567.267z" data-id="element-216" />
              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-13a1 1 0 10-2 0v.092a4.535 4.535 0 00-1.676.662C6.602 6.234 6 7.009 6 8c0 .99.602 1.765 1.324 2.246.48.32 1.054.545 1.676.662v1.941c-.391-.127-.68-.317-.843-.504a1 1 0 10-1.51 1.31c.562.649 1.413 1.076 2.353 1.253V15a1 1 0 102 0v-.092a4.535 4.535 0 001.676-.662C13.398 13.766 14 12.991 14 12c0-.99-.602-1.765-1.324-2.246A4.535 4.535 0 0011 9.092V7.151c.391.127.68.317.843.504a1 1 0 101.511-1.31c-.563-.649-1.413-1.076-2.354-1.253V5z" clipRule="evenodd" data-id="element-217" />
            </svg>
          </div>;
      case 'occupancy':
        return <div className="bg-purple-100 p-2 rounded-full" data-id="element-218">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-purple-600" viewBox="0 0 20 20" fill="currentColor" data-id="element-219">
              <path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z" data-id="element-220" />
            </svg>
          </div>;
      default:
        return <div className="bg-gray-100 p-2 rounded-full" data-id="element-221">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-600" viewBox="0 0 20 20" fill="currentColor" data-id="element-222">
              <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" data-id="element-223" />
            </svg>
          </div>;
    }
  };
  return <div className="flex h-full" data-id="element-224">
      {/* Live Feed Sidebar */}
      <div className="w-60 bg-gray-50 border-r border-gray-200 p-4 overflow-auto" data-id="element-225">
        <h2 className="text-lg font-medium text-gray-700 mb-4" data-id="element-226">Live Feed</h2>
        <nav className="space-y-1" data-id="element-227">
          {/* Live Feed Options */}
          <div className="pt-1 pb-2" data-id="element-228">
            <h3 className="px-3 text-xs font-semibold text-gray-500 uppercase tracking-wider" data-id="element-229">
              Live Feed Options
            </h3>
          </div>
          <button className={`flex items-center w-full px-3 py-2 text-sm font-medium rounded-md ${activeSection === 'activity' ? 'bg-teal-500 text-white' : 'text-gray-700 hover:bg-gray-100'}`} onClick={() => setActiveSection('activity')} data-id="element-230">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-3" viewBox="0 0 20 20" fill="currentColor" data-id="element-231">
              <path d="M5 3a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2V5a2 2 0 00-2-2H5zM5 11a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2v-2a2 2 0 00-2-2H5zM11 5a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V5zM11 13a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" data-id="element-232" />
            </svg>
            Activity Feed
          </button>
          <button className={`flex items-center w-full px-3 py-2 text-sm font-medium rounded-md ${activeSection === 'pricing' ? 'bg-teal-500 text-white' : 'text-gray-700 hover:bg-gray-100'}`} onClick={() => setActiveSection('pricing')} data-id="element-233">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-3" viewBox="0 0 20 20" fill="currentColor" data-id="element-234">
              <path d="M8.433 7.418c.155-.103.346-.196.567-.267v1.698a2.305 2.305 0 01-.567-.267C8.07 8.34 8 8.114 8 8c0-.114.07-.34.433-.582zM11 12.849v-1.698c.22.071.412.164.567.267.364.243.433.468.433.582 0 .114-.07.34-.433.582a2.305 2.305 0 01-.567.267z" data-id="element-235" />
              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-13a1 1 0 10-2 0v.092a4.535 4.535 0 00-1.676.662C6.602 6.234 6 7.009 6 8c0 .99.602 1.765 1.324 2.246.48.32 1.054.545 1.676.662v1.941c-.391-.127-.68-.317-.843-.504a1 1 0 10-1.51 1.31c.562.649 1.413 1.076 2.353 1.253V15a1 1 0 102 0v-.092a4.535 4.535 0 001.676-.662C13.398 13.766 14 12.991 14 12c0-.99-.602-1.765-1.324-2.246A4.535 4.535 0 0011 9.092V7.151c.391.127.68.317.843.504a1 1 0 101.511-1.31c-.563-.649-1.413-1.076-2.354-1.253V5z" clipRule="evenodd" data-id="element-236" />
            </svg>
            Dynamic Pricing
          </button>
        </nav>
      </div>
      {/* Main Content Area */}
      <div className="flex-1 p-6 bg-white overflow-auto" data-id="element-237">
        {activeSection === 'activity' && <div data-id="element-238">
            <h2 className="text-2xl font-semibold text-gray-800 mb-6" data-id="element-239">
              Live Activity Feed
            </h2>
            <div className="bg-gray-50 rounded-lg p-4 border border-gray-200 mb-6" data-id="element-240">
              <p className="text-gray-600" data-id="element-241">
                Real-time updates and activity from your hotel operations
              </p>
            </div>
            <div className="relative" data-id="element-242">
              {/* Live indicator */}
              <div className="absolute top-0 right-0 flex items-center gap-1.5" data-id="element-243">
                <span className="relative flex h-3 w-3" data-id="element-244">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75" data-id="element-245"></span>
                  <span className="relative inline-flex rounded-full h-3 w-3 bg-red-500" data-id="element-246"></span>
                </span>
                <span className="text-sm font-medium text-gray-600" data-id="element-247">LIVE</span>
              </div>
              {/* Activity feed */}
              <div className="space-y-4 mt-6" data-id="element-248">
                {liveFeedItems.map(item => <div key={item.id} className="flex items-start gap-4 p-4 bg-white rounded-lg border border-gray-200 hover:shadow-sm transition-shadow" data-id="element-249">
                    {getActivityIcon(item.type)}
                    <div className="flex-1 min-w-0" data-id="element-250">
                      <p className="text-sm text-gray-800" data-id="element-251">{item.message}</p>
                      <p className="text-xs text-gray-500 mt-1" data-id="element-252">
                        {getRelativeTime(item.timestamp)}
                      </p>
                    </div>
                    <span className={`text-xs font-medium px-2 py-1 rounded-full ${item.type === 'booking' ? 'bg-blue-50 text-blue-700' : item.type === 'revenue' ? 'bg-green-50 text-green-700' : item.type === 'occupancy' ? 'bg-purple-50 text-purple-700' : 'bg-gray-50 text-gray-700'}`} data-id="element-253">
                      {item.type.charAt(0).toUpperCase() + item.type.slice(1)}
                    </span>
                  </div>)}
              </div>
              {/* Load more button */}
              <div className="mt-6 text-center" data-id="element-254">
                <button className="px-4 py-2 bg-white border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50" data-id="element-255">
                  Load more activities
                </button>
              </div>
            </div>
          </div>}
        {activeSection === 'pricing' && <PricingView data-id="element-256" />}
      </div>
    </div>;
};